<app-service-detail #ServiceDetailComponent [context]="context" [location]="'nav.1_registrations'">
  <div class="row w-100 m-0 position-relative">
    <app-list-grid *ngIf="!hideList" class="col-md-12 px-md-5 ml-auto mb-0" [items]="serviceRegistrations"
      [determinantMapById]="determinantMapById" [itemErrorCounts]="registrationErrors" [baseUrl]="baseUrl"
      [inlineAdd]=false [sortable]=true [listToggle]=true [hasTutorial]=true [context]="context"
      [contextProperty]="'service'" [tutorialProperty]="'serviceRegistrations'" [expanded]=true headingTextSize="SMALL"
      [hideSearch]=true removeFromParentText="remove from service" headingText="Registrations in the service"
      editText="to edit the registration" addText="Add" renameText="Click on the registration name to rename the record"
      operationalText="to make the registration operational or not" deleteText="to delete the registration"
      createNewText1Part="Select an existing registration or click on" createNewText2Part="to create a new registration"
      showOperational="true" [newItem]="newRegistration" (createFunction)="showRegistrationAdd = true"
      (saveTutorial)="serviceDetailComponent.updateService()" (updateFunction)="updateRegistration($event)"
      (sortFunction)="sortRegistrations($event)" (deleteFunction)="deleteRegistration($event)"
      (toggleOperationalFunction)="toggleOperational($event)"
      (removeFromParentFunction)="removeRegistrationFromService($event)">
    </app-list-grid>
    <registration-description *ngIf="showRegistrationAdd" [serviceId]="serviceId" [registration]="newRegistration"
      [showRegistrationAdd]="showRegistrationAdd" (modalClosedEvent)="closeLayer();">
    </registration-description>
    <div class="shadow"></div>
    <app-list-grid *ngIf="!hideList" class="col-md-12 px-md-5 ml-auto mt-0 all-registrations"
      [items]="filteredAllRegistrations" [determinantMapById]="determinantMapById"
      [itemErrorCounts]="registrationErrors" [baseUrl]="baseUrl" [inlineAdd]=false [sortable]=true [listToggle]=true
      [expanded]=true [disabledToggleIcons]=false addToParentText="add to service" headingText="All registrations"
      editText="to edit the registration" addText="Add" isCollapsible="true"
      [isCollapsed]="defaultOtherRegListCollapsed" headingTextSize="SMALL"
      renameText="Click on the registration name to rename the record"
      operationalText="to make the registration operational or not" deleteText="to delete the registration"
      createNewText1Part="Select an existing registration or click on" createNewText2Part="to create a new registration"
      showOperational="true" [newItem]="newRegistration" (createFunction)="showRegistrationAdd = true"
      (updateFunction)="updateRegistration($event)" (deleteFunction)="deleteRegistration($event)"
      (toggleOperationalFunction)="toggleOperational($event)" (addToParentFunction)="addRegistrationToService($event)"
      (filterBy)="onNewFilterBy($event)">
    </app-list-grid>

  </div>
  <tab-menu *ngIf="hideList" class="container-fluid px-md-5" [items]="serviceRegistrationActive" [baseUrl]="baseUrl"
    [backToList]="true"></tab-menu>
  <ng-content></ng-content>
</app-service-detail>